import React from 'react';
import { Layout, Image } from 'antd';
import notFound from '@/assets/404.png';

const NotFound = () => {
  return (
    <Layout>
      <Image src={notFound} preview={false} />
    </Layout>
  );
};

export default NotFound;
